import React from "react";
import { View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { TouchableOpacity } from "../../../Buttons";
import { Text } from "../../../Text";
import { useTranslateText } from "@/app/utils/translations";
import { lineItemsTotal } from "@/app/selectors/lineItem";
import { formatMoney } from "@/app/utils/currency";
import ConfirmOrderButton from "./ConfirmOrderButton";
import { confirmBoxStyles as styles } from "./styles";
import { createTposOrder, doCreateOrderStart } from "@/app/actions/order";
import { withForwardRef } from "@/app/utils/withForwardRef";
import { getOptionPriceForBasketLineTotal } from "@/app/selectors/options";

type ConfirmBoxProps = {
  onEditOrderPress: () => void;
};

const ConfirmBox = ({ onEditOrderPress }: ConfirmBoxProps): JSX.Element => {
  const dispatch = useDispatch();
  const { t, locale } = useTranslateText();
  const { priceTotal } = useSelector(lineItemsTotal);
  const confirmDisabled = false;
  const optionPriceForBasketLineTotal = useSelector(
    getOptionPriceForBasketLineTotal,
  );
  const total = priceTotal + optionPriceForBasketLineTotal;

  return (
    <View
      style={styles.container}
      accessible={true}
      accessibilityRole="alert"
      accessibilityLabel="Confirm order box"
    >
      <Text
        style={styles.confirmOrderHeader}
        accessible={true}
        accessibilityRole="header"
        accessibilityLabel={t("tpos.orderArea.confirmOrderHeader")}
      >
        {t("tpos.orderArea.confirmOrderHeader")}
      </Text>
      <Text
        style={styles.confirmOrderText}
        accessible={true}
        accessibilityRole="text"
        accessibilityLabel={"Order confirmation message"}
      >
        {t("tpos.orderArea.confirmOrderText")}
      </Text>
      <View style={styles.buttonRow}>
        <View style={styles.buttonContainer}>
          <View style={styles.editOrderContainer}>
            <TouchableOpacity
              onPress={onEditOrderPress}
              style={styles.editOrderButton}
              accessible={true}
              accessibilityRole="button"
              accessibilityLabel="Edit order button"
              accessibilityHint="Returns to edit the current order"
            >
              <Text style={styles.editOrder}>
                {t("tpos.orderArea.editOrder")}
              </Text>
            </TouchableOpacity>
          </View>
          <View style={styles.confirmOrderContainer}>
            <ConfirmOrderButton
              basketTotal={formatMoney(total, true, locale).amount}
              disabled={confirmDisabled}
              buttonText="tpos.orderArea.confirmOrder"
              onConfirmOrderButtonPress={() => {
                dispatch(doCreateOrderStart());
                dispatch(createTposOrder());
                onEditOrderPress();
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default withForwardRef<HTMLDivElement, ConfirmBoxProps>(ConfirmBox);
